import { useQuery } from 'react-query';
import * as Api from 'api/api';

const useEnums = (enumName) => {
  const initialData = { items: [] };

  const { data = initialData, ...args } = useQuery(
    [enumName, 'all'],
    async () => {
      const { data } = await Api.Enums(enumName);  
                
      const items = data || [];

      return { items };
    },
    { initialData, keepPreviousData: true }
  );

  return { ...data, ...args };
};

export default useEnums;
